import type { DocMigration } from "../docMigration";

function isVirtualRoofBlock(v: any): boolean {
  return typeof v === "object" && v.type === "VIRTUAL_ROOF_BLOCK";
}

function outlineEdgeCount(outline: Array<number>): number {
  return outline.length / 2 - 1;
}

function range(n: number): number[] {
  const a = new Array(n);
  for (let i = 0; i < n; i++) {
    a[i] = i;
  }
  return a;
}

function edgeIdsByOutline(outline: Array<number>): string[] {
  return range(outlineEdgeCount(outline)).map((_, i) => (i + 1).toString());
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_267: DocMigration = {
  maxSchemaVersion: "0.0.267",
  description: "Adds a default roofEdgeOverrides to each roof and creates edgeIds for virtual roofs.",
  apply(json: any): any {
    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const { roofEdgeOverrides = {} } = roof;
      let { blocks } = roof;

      if (isVirtualRoofBlock(blocks)) {
        blocks = {
          ...blocks,
          edgeIds: edgeIdsByOutline(blocks.perimeter),
        };
      }

      roofs[id] = {
        ...roof,
        blocks,
        roofEdgeOverrides,
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_267;
